import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';

//CUSTOM COMPONENTS
import Elemts from './elemts/elemts';
import Dropimage from '../common/dropimage';
import {preview} from './elemts/preview';

//options
const editable = true;
registerLocale('es', es);

//validacion
const val = {
  titulo:e=>{return !(e!='')},
  categoria:[],
  fecha:null,
  tags:[],
  portada:{},
  introduccion:'',
  autor:'',
  fuente:''
}

const Editor = props =>{
  const [error,setError] = useState(false);
  const [categorias,setCategorias] = useState([]);
  const [tags,setTags] = useState([]);
  
  //ELEMTOS LISTA
  const [elemts,setElements] = useState(
    [{"order":0,"key":0,"data":{},"title":"Descripcion"},
    {"order":1,"key":1,"data":{},"title":"Galería"},
    {"order":2,"key":2,"data":{},"title":"Video"}]
  );

  //DATOS DE LA NOTICIA
  const [data,setData] = useState({
    titulo:'',
    categoria:[],
    fecha:null,
    tags:[],
    portada:{},
    introduccion:'',
    autor:'',
    fuente:'',
    fuentelink:'',
    estado:[]
  });

  //validacion
  const val = {
    titulo: error && data.titulo=='',
    categoria: error && data.categoria.length<1,
    fecha: error && data.fecha==null,
    tags: false,
    portada: error && (data.portada.base? data.portada.base=='' : true),
    introduccion: error && data.introduccion=='',
    autor: false,
    fuente: false,
    fuentelink: false,
    estado: error && data.estado.length<1
  }

  //CONSULTAR CATEGORIAS
  const getCategorias = async () =>{
    let response = await fetch('/p_categoria_publicacion', {
        method: 'GET',
        headers:{'Content-Type': 'application/json'}});
    try{
        let res = await response.json();
        setCategorias(res);
    }
    catch{
      
    }
  }
  //CONSULTAR ETIQUETAS
/*   const getEtiquetas = async () =>{
    let response = await fetch('/p_etiquetas_noticias', {
        method: 'POST',
        body: JSON.stringify({}),
        headers:{'Content-Type': 'application/json'}});
    try{
        let res = await response.json();
        setTags(res.resultado[0]);
    }
    catch{
      
    }
} */

  useEffect(() => {
    getCategorias();
    // getEtiquetas();
  }, []);

  //CAMBIOS NOTICIAS
  const set=(name,value)=>{
    if(name!='elemts'){
      var temp = data;
      temp[name]=value;
      setData({
        titulo:temp.titulo,
        categoria:temp.categoria,
        fecha:temp.fecha,
        tags:temp.tags,
        portada:temp.portada,
        introduccion:temp.introduccion,
        autor:temp.autor,
        fuente:temp.fuente,
        fuentelink:temp.fuentelink,
        estado:temp.estado
      });
    }
    else {
      setElements([...value]);
    }
  }

  let lock=true;

  //GUARDAR NOTICIA
  const guardar= async () =>{
    var flag =(data.titulo!=''
            && data.categoria.length>0
            && data.fecha!=null
            && data.portada.base? data.portada.base!='':false
            && data.introduccion!=''
            && data.estado.length>0
          );
    if(flag && lock){
      const toastId = toast.warn('Guardando...', { autoClose: 10000 });
      lock=false;
      const data_send={
        titulo:data.titulo,
        idcategoria:data.categoria[0].ID,
        fechanoticia:data.fecha.toString(),
        portada:data.portada.base,
        introduccion:data.introduccion,
        autor:data.autor,
        fuente:data.fuente,
        fuentelink:data.fuentelink,
        estatus: data.estado[0]=='Oculto'?0:1
      }
      let response = await fetch('/n_noticia', {
        method: 'POST',
        body: JSON.stringify({
          data:data_send,
          tags:data.tags,
          elementos:elemts
        }),
        headers:{'Content-Type': 'application/json'}});
      try{
          let res = await response.json();
          lock=true;
          toast.dismiss(toastId.current);
          if(!res.resultado.error){
            // console.log('Exitoo');
            props.history.push('/publicaciones');
          }
          else{
            setTimeout(()=>toast.warn('Ingrese un título diferente.'),250)
          }
      }
      catch{
        lock=true;
        toast.dismiss(toastId.current);
        setTimeout(()=> toast.warn('Error...'),300)
      }
    }
    else
      setError(true);
  }

  //console.log('NOTICIA',data,elemts);

  return (
    <Fragment>
        <div className="container-fluid">
            <div className="row">
                
                <div className="col-sm-12 mt-3">
                  <div className="row">
                    <div className="col-6 col-sm-4 align-self-center text-sm-left text-center"><h4>Nuevo artículo</h4></div>
                    <div className="col-6 col-sm-8 mb-1 text-right">
                      <button 
                        className="btn btn-success"
                        onClick={guardar}
                      >
                        Guardar
                      </button>
                      {/* <button 
                        className="btn btn-warning"
                        onClick={()=>preview(data,elemts)}
                      >
                         Vista previa
                      </button> */}
                    </div>
                  </div>
                </div>
                
                <div className="col-sm-12" style={{overflowY:'auto',overflowX:'hidden',height:'calc(100vh - 135px)'}}>  
                  <Formulario noticia={data} set={set} list={{categorias,tags}} val={val}/>
                  <Elemts noticia={elemts} set={set} editable={editable}/>
                </div>

            </div>
        </div>
    </Fragment>
  );
}

const Formulario = props =>{
  const {categorias,tags} = props.list;
  const {val} = props;
  const noticia=props.noticia;
  const set = e =>{props.set(e.target.name,e.target.value)}

  return(
    <Fragment>
      <div className="card mt-2">
        <div className="card-body">

          <div className="form-row" >
            {/* INPUT PORTADA */}
            <div className="col-md-4 mb-3">
              <label>Portada</label>
              <Dropimage
                imagen={noticia.portada}
                onUpload={val=>props.set('portada',val)}
                maxSize={307200}
              />
              <span className="error text-danger">
                  {val.portada?'Seleccione una portada':''}
              </span>
            </div>
            <div className="col-md-8 mb-3">
              
              <div className="form-row" >
                {/* INPUT TITULO */}
                <div className="col-md-12 mb-3">
                  <label>Título</label>
                  <input 
                    className="form-control" 
                    name="titulo" 
                    type="text" 
                    autoComplete="off" 
                    placeholder="Título..."
                    value={noticia.titulo}
                    onChange={set}
                  />
                  <span className="error text-danger">
                      {val.titulo?'Ingresa el titulo':''}
                  </span>
                </div>
                {/* INPUT CATEGORIA */}
                <div className="col-md-12 mb-3">
                  <label>Categoría</label>
                  <Typeahead
                    id="c-typeahead"
                    placeholder="Categoría..."
                    options={categorias}
                    clearButton
                    labelKey="NOMBRE"
                    defaultSelected={noticia.categoria}
                    onChange={val=>props.set('categoria',val)}
                    renderMenuItemChildren={(option) => {
                      return [
                          <div key="NOMBRE" >
                              {option.NOMBRE}
                          </div>
                      ];
                    }}
                  />
                  <span className="error text-danger">
                      {val.categoria?'Seleccione una categoría':''}
                  </span>
                </div>
              </div>

            </div>
          </div>

          <div className="form-row">
            {/* INPUT AUTOR */}
            <div className="col-md-4 mb-3">
              <label>Autor</label>
              <input 
                className="form-control" 
                name="autor" 
                type="text" 
                autoComplete="off" 
                placeholder="Autor..."
                value={noticia.autor}
                onChange={set}
              />
            </div>
            {/* INPUT FUENTE */}
            <div className="col-md-4 mb-3">
                <label>Fuente</label>
                <input 
                  className="form-control" 
                  name="fuente" 
                  type="text" 
                  autoComplete="off" 
                  placeholder="Fuente..."
                  value={noticia.fuente}
                  onChange={set}
                />
            </div>
            {/* INPUT FECHA */}
            <div className="col-md-4 mb-3">
              <label>Fecha</label>
              <DatePicker 
                className="form-control digits"
                selected={noticia.fecha}
                onChange={val=>props.set('fecha',val)}
                name="fecha"
                locale="es"
                autoComplete="off"
              />
              <span className="error text-danger">
                  {val.fecha?'Seleccione una fecha':''}
              </span>
            </div>
          </div>

          <div className="form-row">
            {/* INPUT ETIQUETAS */}
            {/* <div className="col-md-8 mb-3">
                <label>Etiquetas</label>
                <Typeahead
                  allowNew
                  multiple
                  id="e-typeahead"
                  newSelectionPrefix="Nueva etiqueta: "
                  placeholder="Etiquetas..."
                  options={tags}
                  labelKey="etiqueta"
                  defaultSelected={noticia.tags}
                  onChange={val=>props.set('tags',val)}
                  renderMenuItemChildren={(option) => {
                    return [
                        <div key="etiqueta" >
                            {option.etiqueta}
                        </div>
                    ];
                  }}
                />
            </div> */}
            <div className="col-md-4 mb-3">
              <label>Estatus</label>
              <Typeahead
                filterBy={opt=>{
                  return true
                }}
                id="e-typeahead"
                placeholder="Estatus..."
                options={['Publico','Oculto']}
                defaultSelected={noticia.estado}
                onChange={val=>props.set('estado',val)}
              />
              <span className="error text-danger">
                  {val.estado?'Seleccione un estatus':''}
              </span>
            </div>
          </div>

          <div className="form-row">
            {/* INPUT INTRODUCCION */}
            <div className="col-md-12 mb-3">
              <label>Introducción</label>
              <input 
                className="form-control" 
                name="introduccion" 
                type="text" 
                autoComplete="off" 
                placeholder="Introducción..." 
                value={noticia.introduccion}
                onChange={set} 
              />
              <span className="error text-danger">
                  {val.introduccion?'Ingresa la introducción':''}
              </span>
            </div>
          </div>

        </div>
      </div>

    </Fragment>
  )
}

export default Editor;